import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { type FC, useMemo } from 'react';
import { cn } from '@/libs/utils';
interface ActionTagProps {
  type: 'all' | 'poll' | 'quiz' | 'challenge' | 'platform' | 'platform_install_app' | 'platform_add_solana_address' | 'platform_register' | 'platform_ee_buy_it_now' | 'platform_ee_auction_bid' | 'platform_admin_coins_grant' | 'platform_referral_purchase' | 'platform_competition_first_visit' | 'platform_referral_registration' | 'platform_coins_purchase' | 'platform_gold_status_purchase' | 'platform_bind_social_media' | 'platform_watch_video' | 'sm_growth_like' | 'sm_growth_comment' | 'sm_growth_share' | 'sm_growth_follow' | 'sm_growth_subscribe' | 'sm_growth_view' | 'sm_growth_listen' | 'sm_growth_watch' | 'sm_growth_celebrity' | 'platform_share_ee' | 'platform_share_celebrity' | 'platform_share_airdrop' | 'platform_share_leaderboard';
}
export const ActionTag: FC<ActionTagProps> = t0 => {
  const $ = _c(10);
  const {
    type
  } = t0;
  const t = useTranslations("experiences.card");
  let t1;
  bb0: {
    if (type === "platform_share_celebrity") {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = <svg className="size-5 lg:size-[26px]" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Celebrity Share</title><path d="M18.125 2.89062H1.875L4.40035 7.33742H10.0651L4.45525 17.1094H9.94513L18.125 2.89062Z" fill="#0091FF" /><path d="M18.1278 2.89062H12.6379L10.1126 7.33742L7.25781 12.2234L10.0028 17.1094L18.1278 2.89062Z" fill="#00B9FF" /></svg>;
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    t1 = null;
  }
  const icon = t1;
  const t2 = icon ? "size-[36px] lg:size-[48px] rounded-full flex items-center justify-center" : "px-3 py-[6px] rounded-[100px]";
  let t3;
  if ($[1] !== t2) {
    t3 = cn("backdrop-blur backdrop-filter bg-[#20202e]", t2);
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== icon || $[4] !== t || $[5] !== type) {
    t4 = icon ? icon : <span className="font-['Inter'] text-[14px] text-[#e9ecf0] leading-[1.3] whitespace-pre">{t(type)}</span>;
    $[3] = icon;
    $[4] = t;
    $[5] = type;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};